module.exports = __webpack_public_path__ + "img/hoverBox1.ccab8a7a.png";